function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M67.09 32.762C61.71 26.51 53.741 22.551 44.847 22.551c-16.197 0-29.326 13.13-29.326 29.326 0 16.196 13.13 29.326 29.326 29.326a29.2 29.2 0 0013.413-3.24"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M56.447 88.866c-4.52-1.632-7.936.623-11.472 6.955-4.871-8.72-9.512-9.708-17.128-3.457-.826-9.82-4.627-12.404-13.985-9.43 2.974-9.358.39-13.16-9.43-13.986 6.25-7.615 5.263-12.256-3.457-17.127 8.72-4.87 9.707-9.511 3.457-17.126 9.82-.827 12.404-4.628 9.43-13.987 9.358 2.975 13.16.391 13.985-9.429 7.616 6.25 12.257 5.263 17.128-3.458 4.87 8.72 9.511 9.708 17.127 3.458.59 7.02 2.7 10.342 7.275 10.58"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M144.007.5l-20.393 108.072H52.602L72.995.5h71.012z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M140.337 3.587L121.11 105.486H56.272L75.5 3.587h64.837z"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "square",
  d: "M118.737 3.516L99.476 105.589M97.129 3.516L77.868 105.589M136.64 23.152H71.816M132.757 43.732H67.93M128.874 64.312H64.048M124.99 84.891H60.166"
}));

function SvgRoomElectricitySolar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 110,
    viewBox: "0 0 145 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricitySolar);
export default __webpack_public_path__ + "static/media/RoomElectricitySolar.ff5ce45b.svg";
export { ForwardRef as ReactComponent };